import { Theme } from '@/components/Theme'
import { AnalyticsProvider } from '@/core/analytics'
import type { AnalyticsData } from '@/models'
import { useBlogArticleCms } from '@/providers/BlogArticleCmsProvider'

import FooterLayout from './FooterLayout'
import HeaderLayout from './HeaderLayout'

interface LayoutProps {
  children?: React.ReactNode
}

export default function BlogArticleLayout({ children }: LayoutProps) {
  const { data, contentReview, footer, adsBottom } = useBlogArticleCms()

  const url = data?.url
  const analytics: AnalyticsData = data?.analytics

  const commonProps = { url, analytics }
  const headerProps = { contentReview, data, ...commonProps }
  const footerProps = { footer, adsBottom, ...commonProps }

  return (
    <Theme data={data}>
      <HeaderLayout {...headerProps} />

      <AnalyticsProvider event={{ ...analytics, url, position: 'meio' }}>
        {children}
      </AnalyticsProvider>

      <FooterLayout {...footerProps} />
    </Theme>
  )
}
